// extracted by mini-css-extract-plugin
module.exports = {"tab":"ProfileTab_tab__PkrBD"};